import * as Yup from "yup"
import { constants } from "config"
import { removeWhiteSpaces } from "config/utils"
import { LocationDocumentTypes } from "config/constants"
import { momentZ } from "config/moment"

const { VALIDATION_REGEX } = constants

const detailsInitialValues = {
	nin: "",
	pin: "",
	city: "",
	type: "",
	email: "",
	image: null,
	branch: "",
	county: "",
	mobile: "",
	lastName: "",
	password: "",
	supplier: "",
	userName: "",
	clientPin: "",
	firstName: "",
	shortName: "",
	telephone: "",
	postalCode: "",
	addressLine1: "",
	addressLine2: "",
	confirmPassword: "",
}

const qualificationsInitialValues = {
	qualification: "",
	startDate: "",
	finishDate: "",
	reference: "",
	siaImage: "",
}
const siaQualificationsInitialValues = {
	reference: "",
	siaImage: "",
}
const hrInitialValues = {
	nin: "",
	dob: "",
	disclosureSentDate: "",
	povaReturnDate: "",
	povaChecked: false,
	disclosureReturnDate: "",
	visaExpiryDate: "",
	name: "",
	addressLine1: "",
	addressLine2: "",
	county: "",
	city: "",
	telephone: "",
	mobile: "",
	relationship: "",
	postalCode: "",
	gender: "",
	disclosureRef: "",
	disclosureLevel: "",
	sex: "",
	nationality: "",
	maritalStatus: "",
	dependants: "",
	hoursAllowed: "",
	visaType: "",
}
const holidayInitialValues = {
	yearlyEntitlement: 0,
	carriedForwardDays: 0,
	holidayYearStartDate: "",
}
const sicknessInitialValues = {
	employeeService: "",
	startDate: "",
	yearlyEntitlement: "",
}
const termsInitialValues = {
	startDate: "",
	finishDate: "",
	payrollTerm: "",
}

const employeeBansInitialValues = {
	selectOption: "",
	branch: "",
	site: "",
	reason: "",
	from: "",
}
const employeeTrainingWorkInitialValues = {
	branch: "",
	site: "",
}

const EmployeeEquipmentSizesInitialValues = {
	cap: "",
	coat: "",
	waist: "",
	chest: "",
	insideLeg: "",
	dress: "",
	collar: "",
	shoes: "",
	gloves: "",
}
const equipmentsInitialValues = {
	employee: "",
	equipmentType: "",
	serialNumber: "",
	quantity: "",
	issueDate: "",
	returnDate: "",
	checked: "",
	nextCheck: "",
	notes: "",
	audit: "",
}
const equipmentsFormInitialValues = {
	equipments: [],
}
const additionalDetailsInitialValues = {
	utrNumber: "",
	shortCode: "",
}
const bankDetailsInitialValues = {
	accountNumber: "",
	bankName: "",
	accountTitle: "",
	sortCode: "",
}

export const employeeDocumentsInitialValues = {
	title: "",
	description: "",
	link: "",
}

const documentsInitialValues = {
	title: "",
	description: "",
	document: "",
}
const trainingInitialValues = {
	branch: "",
	site: "",
}
const usualWorkInitialValues = {
	branch: "",
	site: "",
}
const employeeBanInitialValues = {
	selectFrom: "",
	branch: "",
	site: "",
	customer: "",
	reason: "",
	from: "",
	startDate: "",
	finishDate: "",
}

const bankDetailsValidationSchema = Yup.object().shape({
	accountNumber: Yup.string().required().label("Account Number").trim(),
	bankName: Yup.string().required().label("Bank Name").trim(),
	accountTitle: Yup.string().required().label("Account Title ").trim(),
	sortCode: Yup.string().required().label("Sort code").trim(),
})

const qualificationValidationSchema = Yup.object().shape({
	qualification: Yup.string().required().label("Qualification"),
	startDate: Yup.string().label("Start Date"),
	finishDate: Yup.string().label("Finish Date").nullable(),
	reference: Yup.string().label("Reference").trim(),
	siaImage: Yup.string().label("SIA Image").nullable(),
})

const siaQualificationValidationSchema = Yup.object().shape({
	reference: Yup.string().label("Reference"),
	siaImage: Yup.string().label("SIA Image"),
})

export const employeeDocumentValidationSchema = Yup.object().shape({
	title: Yup.string().required().label("Title").trim(),
	description: Yup.string().required().label("Description").trim(),
	link: Yup.string().required().label("Document"),
})

const documentsValidationSchema = Yup.object().shape(
	{
		title: Yup.string().required().label("Title").trim(),
		description: Yup.string().required().label("Description").trim(),
		link: Yup.string().required().label("Document"),
		type: Yup.string().required().label("Type"),
		startDate: Yup.string()
			.when("type", {
				is: (value: any) => value === LocationDocumentTypes.ASSIGNMENT_INSTRUCTIONS,
				then: rule => rule.required(),
			})
			.notRequired()
			.nullable()
			.label("startDate"),
		isApproved: Yup.boolean()
			.when("type", {
				is: (value: any) => value === LocationDocumentTypes.ASSIGNMENT_INSTRUCTIONS,
				then: rule => rule.required(),
			})
			.notRequired()
			.nullable()
			.label("isApproved"),
		endDate: Yup.string()
			.when("type", {
				is: (value: any) => value === LocationDocumentTypes.ASSIGNMENT_INSTRUCTIONS,
				then: rule => rule.required(),
			})
			.notRequired()
			.nullable()
			.label("endDate"),
	},
	[
		["startDate", "startDate"],
		["endDate", "endDate"],
	],
)

const additionalDetailsValidationSchema = Yup.object().shape({
	utrNumber: Yup.number().required().label("UTR Number"),
	shortCode: Yup.string().label("Short Code").trim(),
})
const EmployeeEquipmentSizesValidationSchema = Yup.object().shape({
	cap: Yup.string().required().label("Hard Hat").trim(),
	coat: Yup.string().required().label("High Visibility Jacket").trim(),
	waist: Yup.string().required().label("Waist").trim(),
	chest: Yup.string().required().label("Chest").trim(),
	insideLeg: Yup.string().required().label("Inside Leg").trim(),
	dress: Yup.string().optional().label("Dress").trim(),
	collar: Yup.string().required().label("Collar").trim(),
	shoes: Yup.string().required().label("Shoes").trim(),
	gloves: Yup.string().required().label("Gloves").trim(),
})
const employeeBansValidationSchema = Yup.object().shape({
	branch: Yup.string().required().label("Branch"),
	site: Yup.string().required().label("Site"),
	reason: Yup.string().required().label("Reason"),
	from: Yup.string().required().label("From"),
})
const employeeTrainingWorkValidationSchema = Yup.object().shape({
	branch: Yup.string().required().label("Branch"),
	site: Yup.string().required().label("Site"),
})

const termsValidationSchema = Yup.object().shape({
	startDate: Yup.string().required().label("Start Date"),
	finishDate: Yup.string().nullable().label("Finish Date"),
	pbTerm: Yup.string().required().label("Payroll Term"),
})
const sicknessValidationSchema = Yup.object().shape({
	sicknessYearStartDate: Yup.string().required().label("Sickness Start Date"),
	entitledDays: Yup.number().required().label("Entitled Days"),
})
const holidayValidationSchema = Yup.object().shape({
	holidayYearStartDate: Yup.string().required().label("Holiday Yearly Start Date"),
	yearlyEntitlement: Yup.string().required().label("Yearly Entitlement"),
	carriedForwardDays: Yup.string().required().label("Carried Forward Days"),
})
const hrValidationSchema = Yup.object().shape(
	{
		nin: Yup.string().required().label("NI Number").matches(VALIDATION_REGEX.nin, "Invalid NI Number"),
		dob: Yup.string()
			.transform(value => (value === "" ? null : value))
			.nullable()
			.label("Date of Birth"),
		gender: Yup.string().notRequired().label("Gender").nullable(),
		nationality: Yup.string().notRequired().label("Nationality").nullable(),
		maritalStatus: Yup.string().notRequired().label("Marital Status").nullable(),
		dependants: Yup.string().notRequired().label("Dependants"),
		visaExpiryDate: Yup.string()
			.transform(value => (value === "" ? null : value))
			.nullable()
			.label("Visa Expiry Date"),
		lastCheckedOn: Yup.string()
			.transform(value => (value === "" ? null : value))
			.nullable()
			.label("Last Checked On"),
		nextCheckDue: Yup.string()
			.nullable()
			.when("lastCheckedOn", {
				is: (value: any) => value?.length,
				then: rule => rule.required().label("Next Check Due"),
			}),
		disclosureRef: Yup.string().label("Disclosure Ref").trim().nullable(),
		disclosureLevel: Yup.string().label("Disclosure Level").nullable(),
		disclosureSentDate: Yup.string()
			.transform(value => (value === "" ? null : value))
			.nullable()
			.label("Disclosure Sent Date"),
		povaChecked: Yup.boolean().label("Pova Checked"),
		povaReturnDate: Yup.string()
			.transform(value => (value === "" ? null : value))
			.nullable()
			.label("Pova Return Date"),
		disclosureReturnDate: Yup.string()
			.transform(value => (value === "" ? null : value))
			.nullable()
			.label("Disclosure Return Date"),
		name: Yup.string().notRequired().label("Name").trim().nullable(),
		relationship: Yup.string().notRequired().label("Relationship").trim().nullable(),
		addressLine1: Yup.string().notRequired().label("Address Line 1").nullable(),
		addressLine2: Yup.string().label("Address Line 2").nullable(),
		county: Yup.string().notRequired().label("County").nullable(),
		city: Yup.string().notRequired().label("City").trim().nullable(),
		postalCode: Yup.string()
			.label("Postal code")
			.notRequired()
			.nullable()
			.when("postalCode", {
				is: (value: any) => value?.length,
				then: rule => rule.matches(VALIDATION_REGEX.postalCode, "Invalid Postal Code"),
			}),
		telephone: Yup.string()
			.label("Telephone")
			.nullable()
			.notRequired()
			.when("telephone", {
				is: (value: any) => value?.length,
				then: rule => rule.matches(VALIDATION_REGEX.phone, "Invalid Telephone Number"),
			}),
		mobile: Yup.string()
			.label("Mobile")
			.nullable()
			.notRequired()
			.when("mobile", {
				is: (value: any) => value?.length,
				then: rule => rule.matches(VALIDATION_REGEX.mobile, "Invalid Mobile Number"),
			}),
		hoursAllowed: Yup.number()
			.positive()
			.integer()
			.transform(value => (isNaN(value) ? undefined : value))
			.label("Hours Allowed"),
		visaType: Yup.string().label("Visa Type").nullable(),
	},
	[
		["telephone", "telephone"],
		["mobile", "mobile"],
		["postalCode", "postalCode"],
		["nextCheckDue", "nextCheckDue"],
	],
)

const servicesInitialValues = {
	startDate: "",
	finishDate: "",
	staffNumber: "",
	payGroup: "",
	minHours: "",
	maxHours: "",
	averagedOver: "",
	minEvents: "",
	maxEvents: "",
	proRata: "",
	additionalContractHours: "",
}

const servicesValidationSchema = Yup.object().shape({
	startDate: Yup.string().required().label("Start Date"),
	finishDate: Yup.string()
		.transform(value => (value === "" ? null : value))
		.nullable()
		.label("Finish Date"),
	staffNumber: Yup.string().label("Staff Number").nullable().trim(),
	payGroup: Yup.string().nullable().label("Pay Group"),
	minHours: Yup.number()
		.nullable()
		.positive()
		.integer()
		.transform((value, originalValue) => (originalValue === "" ? undefined : value))
		.typeError("Min Hour must be a number")
		.label("Min Hours Per Week"),
	maxHours: Yup.number()
		.nullable()
		.positive()
		.integer()
		.transform((value, originalValue) => (originalValue === "" ? undefined : value))
		.typeError("Max Hour must be a number")
		.label("Min Hours Per Week"),
	averagedOver: Yup.number()
		.nullable()
		.positive()
		.integer()
		.transform((value, originalValue) => (originalValue === "" ? undefined : value))
		.typeError("Averaged Over must be a number")
		.label("Averaged Over"),
	minEvents: Yup.number()
		.nullable()
		.transform((value, originalValue) => (originalValue === "" ? undefined : value))
		.typeError("Min Events must be a number")
		.label("Min Events Per Week"),
	maxEvents: Yup.number()
		.nullable()
		.positive()
		.integer()
		.transform((value, originalValue) => (originalValue === "" ? undefined : value))
		.typeError("Max Events must be a number")
		.label("Max Events Per Week"),
	proRata: Yup.number()
		.nullable()
		.positive()
		.integer()
		.transform((value, originalValue) => (originalValue === "" ? undefined : value))
		.typeError("Pro Rate must be a number")
		.nullable()
		.label("Pro Rata"),
	additionalContractHours: Yup.number()
		.nullable()
		.positive()
		.integer()
		.transform((value, originalValue) => (originalValue === "" ? undefined : value))
		.typeError("Additional Contract Hours must be a number")
		.label("Additional Contract Hours"),
})
const equipmentsValidationSchema = Yup.object().shape({
	serialNumber: Yup.string().label("Size/Sr No.").nullable().trim(),
	equipmentType: Yup.string().required().label("Equipment"),
	quantity: Yup.string().required().label("Quantity").trim(),
	issueDate: Yup.string().required().label("Issued Date"),
	returnDate: Yup.string()
		.transform(value => (value === "" ? null : value))
		.label("Return Date")
		.nullable(),
	checked: Yup.string()
		.transform(value => (value === "" ? null : value))
		.label("Checked Date")
		.nullable(),
	nextCheck: Yup.string()
		.transform(value => (value === "" ? null : value))
		.label("Next Check")
		.nullable(),
	notes: Yup.string().label("Notes").nullable().trim(),
	audit: Yup.string().nullable().trim(),
	customer: Yup.string().required().label("Customer"),
})

const detailsValidationSchema = Yup.object().shape(
	{
		nin: Yup.lazy(value => {
			if (!value || value === "" || value === "#") return Yup.string().notRequired()

			return Yup.string().label("NI Number").matches(VALIDATION_REGEX.nin, "Invalid NI Number")
		}),
		branch: Yup.string()
			.when("supplier", {
				is: (value: any) => !value?.length,
				then: rule => rule.required(),
			})
			.notRequired()
			.nullable()
			.label("Branch"),
		supplier: Yup.string()
			.when("Supplier", {
				is: (value: any) => value?.length,
				then: rule => rule.matches(VALIDATION_REGEX.mongoId, "Invalid Supplier"),
			})
			.notRequired()
			.nullable()
			.label("Supplier"),
		firstName: Yup.string()
			.required()
			.matches(
				VALIDATION_REGEX.nameRegex,
				"Only alphabets, numbers, spaces, hyphens, and apostrophes are allowed",
			)
			.label("First name")
			.trim()
			.max(50, "First Name can't exceed 50 characters"),

		lastName: Yup.string()
			.required()
			.matches(
				VALIDATION_REGEX.nameRegex,
				"Only alphabets, numbers, spaces, hyphens, and apostrophes are allowed",
			)
			.label("Last name")
			.trim()
			.max(50, "Last Name can't exceed 50 characters"),
		shortName: Yup.string()
			.required()
			.matches(
				VALIDATION_REGEX.nameRegex,
				"Only alphabets, numbers, spaces, hyphens, and apostrophes are allowed",
			)
			.label("Short Name")
			.trim()
			.max(20, "Short Name can't exceed 20 characters"),
		type: Yup.string().required().label("Type"),
		addressLine1: Yup.string().label("Address line 1").trim(),
		addressLine2: Yup.string().label("Address Line 2").trim(),
		city: Yup.string()
			.when("city", {
				is: (value: any) => value?.length,
				then: rule => rule.min(3),
			})
			.label("City"),
		county: Yup.string()
			.when("county", {
				is: (value: any) => value?.length,
				then: rule => rule.min(3),
			})
			.label("County"),
		postalCode: Yup.string()
			.label("Postal code")
			.nullable()
			.notRequired()
			.transform(value => removeWhiteSpaces(value))
			.when("postalCode", {
				is: (value: any) => value?.length,
				then: rule => rule.matches(VALIDATION_REGEX.postalCode, "Invalid Postal Code"),
			}),
		telephone: Yup.string()
			.label("Telephone")
			.nullable()
			.notRequired()
			.when("telephone", {
				is: (value: any) => value?.length,
				then: rule => rule.matches(VALIDATION_REGEX.phone, "Invalid Telephone Number"),
			}),
		mobile: Yup.string()
			.matches(/^[0-9]*$/, "Invalid mobile number")
			.label("Mobile"),
		email: Yup.string().email().label("Email"),
		thumbnail: Yup.string().label("Upload Image").nullable(),
		// userName: Yup.lazy(value => {
		// 	if (value && value === "#") return Yup.string().notRequired()
		// 	return Yup.string()
		// 		.required("Username is a required field")
		// 		.min(6, "Username must be between 6-20 characters long")
		// 		.matches(
		// 			VALIDATION_REGEX.usernameCheckI,
		// 			"Username must contains only letters, numbers, dots, and underscores",
		// 		)
		// 		.matches(VALIDATION_REGEX.usernameCheckII, "Username can not contain consecutive dots or underscores")
		// 		.matches(VALIDATION_REGEX.usernameCheckIII, "Username can not start or end with dot or underscores")
		// 		.max(20, "Username must be between 6-20 characters long")
		// }),
		password: Yup.lazy(value => {
			if (value && value === "#") return Yup.string().notRequired()
			return Yup.string()
				.required()
				.min(6, "Password is too short - should be 6 chars minimum.")
				.label("Password")
		}),
		confirmPassword: Yup.lazy(value => {
			if (value && value === "#") return Yup.string().notRequired()
			return Yup.string()
				.required()
				.oneOf([Yup.ref("password"), null], "Passwords does not match")
				.label("Confirm Password")
		}),
		clientPin: Yup.string()
			.nullable()
			.notRequired()
			.when("clientPin", {
				is: (value: any) => value?.length,
				then: rule => rule.matches(/^\d+$/, "Client PIN can only be number"),
			})
			.label("Client Pin"),
	},
	[
		["telephone", "telephone"],
		["userName", "userName"],
		["password", "password"],
		["confirmPassword", "confirmPassword"],
		["postalCode", "postalCode"],
		["county", "county"],
		["city", "city"],
		["branch", "branch"],
		["supplier", "supplier"],
		["clientPin", "clientPin"],
	],
)

const employeeTrainingValidationSchema = Yup.object().shape({
	branch: Yup.string().required().label("Branch"),
	site: Yup.string().required().label("Site"),
})
const employeeUsualWorkValidationSchema = Yup.object().shape({
	branch: Yup.string().required().label("Branch"),
	site: Yup.string().required().label("Site"),
})
const employeeBanValidationSchema = Yup.object().shape(
	{
		branch: Yup.string().when("selectOption", {
			is: "branch",
			then: schema => schema.required("Branch is required"),
			otherwise: schema => schema.notRequired(),
		}),
		site: Yup.string().when("selectOption", {
			is: "site",
			then: schema => schema.required("Site is required"),
			otherwise: schema => schema.notRequired(),
		}),
		customer: Yup.string().when("selectOption", {
			is: "customer",
			then: schema => schema.required("Customer is required"),
			otherwise: schema => schema.notRequired(),
		}),
		selectOption: Yup.string().label("Ban From"),
		reason: Yup.string().required().label("Reason"),
		from: Yup.string().required().label("From").nullable(),
		startDate: Yup.string().required().label("Start Date"),
		finishDate: Yup.string().label("Finish Date").nullable(),
		isActive: Yup.string().label("Is Active").nullable(),
	},
	[
		["branch", "branch"],
		["site", "site"],
		["customer", "customer"],
	],
)

const LdnInitialValues = {
	documentPath: "",
	startDate: momentZ().toISOString(),
	endDate: momentZ().toISOString(),
	reference: "",
}

const LdnValidationSchema = Yup.object().shape({
	documentPath: Yup.string().required().label("LDN Document"),
	startDate: Yup.string().required().label("LDN Start Date"),
	endDate: Yup.string().required().label("LDN End Date"),
	reference: Yup.string().required().label("LDN Reference").trim(),
})

const pbCodeDetailsSchema = Yup.object().shape({
	paycodes: Yup.array().of(
		Yup.object().shape({
			pbCode: Yup.string().required(),
			site: Yup.string().required(),
		}),
	),
})

const EmployeeAddressesSchema = Yup.object().shape({
	address: Yup.string().required().label("Address"),
})

export {
	siaQualificationsInitialValues,
	siaQualificationValidationSchema,
	detailsValidationSchema,
	detailsInitialValues,
	servicesInitialValues,
	servicesValidationSchema,
	hrInitialValues,
	hrValidationSchema,
	holidayInitialValues,
	holidayValidationSchema,
	sicknessInitialValues,
	sicknessValidationSchema,
	termsInitialValues,
	termsValidationSchema,
	employeeBansInitialValues,
	employeeBansValidationSchema,
	employeeTrainingWorkInitialValues,
	employeeTrainingWorkValidationSchema,
	equipmentsInitialValues,
	equipmentsFormInitialValues,
	EmployeeEquipmentSizesInitialValues,
	EmployeeEquipmentSizesValidationSchema,
	additionalDetailsInitialValues,
	bankDetailsInitialValues,
	additionalDetailsValidationSchema,
	documentsInitialValues,
	documentsValidationSchema,
	qualificationsInitialValues,
	qualificationValidationSchema,
	bankDetailsValidationSchema,
	equipmentsValidationSchema,
	trainingInitialValues,
	employeeTrainingValidationSchema,
	usualWorkInitialValues,
	employeeUsualWorkValidationSchema,
	employeeBanInitialValues,
	employeeBanValidationSchema,
	LdnValidationSchema,
	LdnInitialValues,
	pbCodeDetailsSchema,
	EmployeeAddressesSchema,
}
